import Swiper, {EffectCards, Navigation, Pagination} from "swiper";

Swiper.use([EffectCards, Navigation, Pagination])
export function initGallerySlider(){

    let swiper = new Swiper('#gallery_slider', {
        loop: true,
        speed: 800,
        centeredSlides: true,
        slidesPerView: "auto",
        preloadImages: false,
        allowTouchMove: false,
        spaceBetween: 0,
        initialSlide: 0,
        cardsEffect: {
            rotate: false,
            slideShadows: false,
            perSlideRotate: 0,
            perSlideOffset: 37
        },
        navigation: {
            nextEl: '.gallery-next-button',
            prevEl: '.gallery-prev-button',
        },
        pagination:{
            el: '.slider-pagination',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
            },
            500: {
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
            },
            1280: {
                slidesPerView: 'auto',
                spaceBetween: 0,
            }
        }
    });
}